import { Dispatch, SetStateAction, useState } from "react";
import DateFilter from "./DateFilter";
import SideFilter from "./SideFilter";
import { TrashIcon } from "../../icons";
import { Button } from "@ac-expo/ui-components";
import filterStore from "../../services/FilterStore";
import { observer } from "mobx-react-lite";
import { EventDataType, FilterCardMenu } from "./FilterCardMenu/FilterCardMenu";
import { SearchRadiusFilter } from "./SearchRadiusFilter";
import EventTypeFilter from "./EventTypeFilter";

interface FilterBarDesktopProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
  setRadius: (radius: number) => void;
  radius: number;
  reset?: () => void;
}

export const FilterBarDesktop = observer(
  ({ startDate, endDate, setRadius, radius, reset }: FilterBarDesktopProps) => {
    const [activeData, setActiveData] = useState<EventDataType>("events");

    return (
      <div className="flex grow flex-row items-stretch">
        <FilterCardMenu
          activeData={filterStore.activeData}
          setActiveData={setActiveData}
        />
        <div className="flex h-16 grow items-center gap-6 border-l border-gray-300 px-6 ">
          <p className="whitespace-nowrap text-base font-normal text-black ">
            Filtres
          </p>
          <div className="flex h-[41px] grow items-center gap-2">
            <div className="flex h-[41px] grow items-center rounded-lg border-gray-300">
              <SearchRadiusFilter setRadius={setRadius} radius={radius} />
            </div>
            <div className="flex grow gap-2">
              <div className="flex grow">
                <DateFilter startDate={startDate} endDate={endDate} />
              </div>
              <div className="flex grow">
                {activeData === "events" && <EventTypeFilter />}
                {/* {activeData === "places" && <PlaceTypeFilter />} */}
                {/* {activeData === "all" && (
                  <div className={"grow gap-2"}>
                    <BothTypeFilter />
                  </div>
                )} */}
              </div>
              <div className="flex grow">
                <SideFilter />
              </div>
              {reset !== undefined && (
                <div className="flex items-center">
                  <Button
                    className="h-[41px] w-full justify-between bg-white font-normal text-gray-500"
                    onClick={reset}
                  >
                    <TrashIcon width={18} height={18} fill={"red"} />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default FilterBarDesktop;
